import { i18n } from '@/localization'
import { Affix, Alert, Anchor, AutoComplete, Avatar, BackTop, Badge, Breadcrumb, Button, Calendar, Card, Carousel, Cascader, Checkbox, Col, Collapse, DatePicker, Divider, Drawer, Dropdown, Form, Icon, Input, InputNumber, Layout, List, LocaleProvider, Menu, Message, message, Modal, notification, Pagination, Popconfirm, Popover, Progress, Radio, Rate, Row, Select, Skeleton, Slider, Spin, Steps, Switch, Table, Tabs, Tag, Timeline, TimePicker, Tooltip, Transfer, Tree, TreeSelect, Upload } from 'ant-design-vue'
import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
import injector from 'vue-inject'
import NProgress from 'vue-nprogress'
import VuePageTitle from 'vue-page-title'
import VueLogger from 'vuejs-logger'
import VueLayers from 'vuelayers'
import VueGoodTablePlugin from 'vue-good-table'
import App from './App.vue'
import './global.scss'
import router from './router'
import store from './store'

import 'vue-good-table/dist/vue-good-table.css'

const isProduction = process.env.NODE_ENV === 'production'

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: false,
  showMethodName: false,
  separator: '|',
  showConsoleColors: true,
}

Vue.use(VueLogger, options)
Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(Skeleton)
Vue.use(Avatar)
Vue.use(Popconfirm)
Vue.use(Transfer)
Vue.use(Modal)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Timeline)
Vue.use(Tree)
Vue.use(Popover)
Vue.use(List)
Vue.use(Card)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Anchor)
Vue.use(AutoComplete)
Vue.use(Collapse)
Vue.use(BackTop)
Vue.use(LocaleProvider)
Vue.use(VueGoodTablePlugin)

Vue.prototype.$notification = notification
Vue.prototype.$message = message

Vue.use(NProgress)

require('./inject')

Vue.use(injector)
Vue.use(VuePageTitle, {
  prefix: 'Kontigo | ',
  router,
})

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
